{
  "admins": {
    "errors": {
      "add": "Echèk nan ajoute administratè a.",
      "notFound": "Pa t ka jwenn administratè sa a."
    }
  },
  "home": {
    "goToSandbox": "Ale nan sandbox la",
    "subtitle": "Depo sa a se yon kòmansman pou konstwi aplikasyon entènèt yo ak React, shadcn-ui ak TanStack Router.",
    "title": "Byenveni nan Modèl React Mindsea a."
  },
  "login": {
    "errors": {
      "invalidEmail": "Tanpri antre yon adrès imèl ki valab.",
      "unauthorized": "Ou pa gen otorizasyon pou w aksè aplikasyon sa a."
    },
    "placeholder": "email@egzanp.com",
    "sendCode": "Voye kòd la",
    "subtitle": "Konstwi paj koneksyon an isit la.",
    "title": "Konekte"
  }
}
